import axios from "axios";

export async function addToCart(item) {
    let token = '123456789';
    let response = await axios.put(
        '/services/cart',
        {
            item: {
                qty: item.qty,
                variation_id: item.variation_id
            }
        },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.status === 200;
}

export async function updateCart(cart) {
    let token = '123456789';
    let response = await axios.post(
        '/services/cart',
        {
            cart
        },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.status === 200;
}

export async function loadCart() {
    let token = '123456789';
    let response = await axios.get(
        '/services/cart',
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.status === 200 && response.data ? response.data : null;
}
